<template>
  
  <div id="app">
    <div class="section">
      <img src="~@/assets/imgs/air.png" alt="" class="logo-img" />
      <p class="title">{{ name }}</p>
      <p class="money">
        <label class="money-unit">{{ unit }}</label>
        &nbsp;
        <label class="money-price">{{ price }}</label>
      </p>
    </div>

    <div class="shop-panel">
      <p class="shop-text" style="color: palegoldenrod;">清糖与AIR绑定后，可领取 30天 黄金VIP特权</p>
      <p class="shop-text">如果您需要咨询产品使用方法、操作技巧等问题，可拨打客服电话：13728621594</p>
      <p class="shop-text" style="color: orange;">声明：购买“清糖AIR 2”硬件，并不包含清糖App中的软件功能；例如：AIR数据上报、医用版传感器、闭环同步数据等功能，需要开通特权才能享有；特权详情，可前往“会员中心”详细了解；</p>
    </div>


    <div class="info-panel">
      <p class="info-desc">—— —— —— 商品详情 —— —— ——</p>
      <div v-for="item in list" :key="item.id" class="info-item">
        <img :src="item.src" alt="" style="width: 100%" />
      </div>
    </div>

    <div class="placeholder">

    </div>

    <div class="float-panel">

      <div v-show="token == ''">
        <input ref="loginPhone" type="text" placeholder="请输入手机号" class="form-control">
        <div>
          <input ref="loginCode" type="text" placeholder="请输入验证码" class="form-control text-code">
          <button ref="btnSendCode" class="form-button button-code" @click="sendCode()">
            发送
          </button>
        </div>
        <button class="form-button" @click="login()">
          登录 / 注册
        </button>
      </div>

      <div v-show="token != ''">
<!--        <div class="wechat-dev">-->
<!--          <img src="~@/assets/imgs/icon_wechat.jpg" alt="" class="wechat-icon" />-->
<!--          <label class="wechat-desc">微信支付</label>-->
<!--        </div>-->
        <button class="form-button button-pay" @click="fill()">
          {{ isSafari ? "打开清糖App" : "立即购买" }}
        </button>
        <button class="form-button" @click="gotoOrder()">
          我的订单
        </button>
      </div>
    </div>

    <div v-show="isPay" class="pay-panel">
      <div v-show="orderId == ''" class="fill-start">
        <p class="fill-title">收货信息</p>
        <div class="fill-body">
          <input ref="fillPhone" type="text" placeholder="手机号" class="form-control" :value="fillPhone">
          <input ref="fillName" type="text" placeholder="收件人" class="form-control" :value="fillName">
          <input ref="fillAddress" type="text" placeholder="详细地址" class="form-control" :value="fillAddress">
<!--          <div class="wechat-dev">-->
<!--            <img src="~@/assets/imgs/icon_wechat.jpg" alt="" class="wechat-icon" />-->
<!--            <label class="wechat-desc">微信支付</label>-->
<!--          </div>-->
          <button class="form-button button-pay" @click="pay()">
            立即支付 ¥{{ price }}
          </button>
          <button class="form-button button-cancel" @click="cancel()">
            取消购买
          </button>
        </div>
      </div>
      <div v-show="orderId != ''" class="pay-result">

        <div class="result-status">
          <p class="result-wait">等待付款</p>
          <p class="result-result">{{ payResult }}</p>
        </div>

        <div>
          <p class="result-text">
            请根据您的支付情况
          </p>
          <p class="result-text">
            点击下面按钮
          </p>
          <button class="form-button button-pay" @click="getPayResult()">
            支付完成
          </button>
          <button class="form-button button-cancel" @click="cancel()">
            {{ isSafari ? "打开清糖App" : "暂不付款" }}
          </button>
          <div>
            <p class="result-after-content">支付遇到问题？请联系客服人员获取帮助；</p>
            <p class="result-after-content">电话：13728621594</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {addOrder, getPayResult, sendCode, login, getCommodity, getUserInfo} from "@/api/air";

import _04 from "./image/04.jpg";
import _06 from "./image/06.jpg";
import _07 from "./image/07.jpg";
import _08 from "./image/08.jpg";
import _09 from "./image/09.jpg";
import _10 from "./image/10.jpg";

import {
  checkSafari,
  getQueryString,
} from "@/utils/common";

export default {
  name: "App",
  components: { },
  data() {
    return {
      token: getQueryString("token"),
      orderId: getQueryString("orderId"),
      isPay: getQueryString("orderId") != '',
      v: getQueryString("v"),
      isSafari: checkSafari(),
      commodityId: 0,
      name: "清糖AIR 2",
      price: 698,
      unit: "¥",
      list: [
        {id: "07", src: _07},
        {id: "08", src: _08},
        {id: "04", src: _04},
        {id: "06", src: _06},
        {id: "09", src: _09},
        {id: "10", src: _10},
      ],
      fillPhone: "",
      fillName: "",
      fillAddress: "",
      payResult: "",
    };
  },
  async mounted() {

    if(this.orderId != "" && this.isSafari) {
      location.href = "sensemedglu://";
    }

    const res = (await getCommodity()).data;
    this.commodityId = res.id;
    this.name = res.name;
    this.price = res.price;
    // this.unit = res.unit;
    // this.list = res.list;
  },
  methods: {
    async sendCode() {

      let phoneNumber = this.$refs.loginPhone.value;

      if(phoneNumber == "") {
        this.$toasted.show("请输入手机号");
        return;
      }

      const res = await sendCode({
        "phoneNumber": phoneNumber,
      });

      if(res.code != 200) {
        this.$toasted.show(res.message);
        return;
      }

      this.$toasted.show("验证码发送成功");
      this.$refs.btnSendCode.innerHTML = "已发送";
      this.$refs.btnSendCode.disabled = true;
    },
    async login() {
      let phoneNumber = this.$refs.loginPhone.value;
      let checkCode = this.$refs.loginCode.value;

      if(phoneNumber == "") {
        this.$toasted.show("请输入手机号");
        return;
      }

      if(checkCode == "") {
        this.$toasted.show("请输入验证码");
        return;
      }

      const res = await login({
        "phoneNumber": phoneNumber,
        "checkCode": checkCode,
      });

      if(res.code != 200) {
        this.$toasted.show(res.message);
        return;
      }

      let token = res.data["tokenId"];
      location.href = "/app-pages/air.html?token=" + token + "&v=" + this.v;
    },
    async fill() {

      if(this.isSafari) {
        location.href = "sensemedglu://";
        return;
      }

      const res = await getUserInfo(this.token);

      if(res.code != 200) {
        this.$toasted.show(res.message);
        return;
      }

      this.isPay = true;
      this.fillPhone = res.data.phone ?? "";
      this.fillName = res.data.name ?? "";
    },
    cancel() {
      if(this.isSafari) {
        location.href = "sensemedglu://";
        return;
      }

      location.href = "/app-pages/air.html?token=" + this.token + "&v=" + this.v;
    },
    async pay() {

      if(this.isSafari) {
        location.href = "sensemedglu://";
        return;
      }

      let phoneNumber = this.$refs.fillPhone.value;
      let name = this.$refs.fillName.value;
      let address = this.$refs.fillAddress.value;

      if(phoneNumber == "") {
        this.$toasted.show("请输入手机号");
        return;
      }

      if(name == "") {
        this.$toasted.show("请输入收件人");
        return;
      }

      if(address == "") {
        this.$toasted.show("请输入详细地址");
        return;
      }

      const res = await addOrder({
        "commodityId": this.commodityId,
        "phone": phoneNumber,
        "name": name,
        "address": address,
      }, this.token);

      if(res.code != 200) {
        this.$toasted.show(res.message);
        return;
      }

      // alert("亲爱的审核人员：由于微信支付未开通，我们将跳过真实的支付流程，直接进入支付结果页面，请您继续审核，万分感谢！");
      this.orderId = res.data.orderId;
      location.href = res.data.h5Url;
    },
    async getPayResult() {
      const res = await getPayResult(this.orderId, this.token);

      if(res.code != 200) {
        this.payResult = res.message;
        return;
      }

      this.gotoOrder();
    },
    gotoOrder() {
      location.href = "/app-pages/order.html?token=" + this.token + "&v=" + this.v;
    },
  }
};
</script>

<style lang="scss">
body {
  background-color: #111111;
}

#app {
  font-family: Open Sans, -apple-system, BlinkMacSystemFont, Helvetica Neue,
    Helvetica, Segoe UI, Arial, Roboto, PingFang SC, miui, Hiragino Sans GB,
    Microsoft Yahei, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #323233;
  font-size: 14px;
  text-align: center;
}

.section {
  margin-top: 4vh;
}

.logo-img {
  //width: 40vw;
  height: 24vh;
  object-fit: contain;
  //margin-top: 2vh;
  //margin-left: -12px;
}

.title {
  font-size: 40px;
  font-weight: 500;
  //margin-top: 2vh;
  //color: #666;
  color: gold;
}

.money {
  margin-top: 1vh;
  //color: #666;
  color: gold;
}

.money-unit {
  font-size: 26px;
  font-weight: 800;
}

.money-price {
  font-size: 32px;
  font-weight: 800;
}

.shop-panel {
  margin-top: 24px;
  background-color: #323233;
  margin-left: 2vh;
  margin-right: 2vh;
  padding: 8px 12px;
  text-align: left;
}

.shop-text {
  font-size: 16px;
  font-weight: 250;
  color: white;
  line-height: 32px;
}

.info-panel {
  margin-top: 24px;
}

.info-desc {
  font-size: 20px;
  font-weight: 500;
  color: white;
  margin-bottom: 24px;
}

.info-item {
  background-color: #323233;
  margin-top: 1vh;
  margin-left: 2vh;
  margin-right: 2vh;
}

.placeholder {
  height: 26vh;
  //background: red
}

.float-panel {
  position: fixed;
  left: 0vh;
  right: 0vh;
  bottom: 0vh;
  z-index: 999;
  background-color: steelblue;
  opacity: 0.96;
  color: black;
  padding: 0 2vh;
  text-align: center;
  border-radius: 6pt;
}

.form-control {
  margin-top: 2vh;
  background-color: #FFFFFF;
  background-image: none;
  border: 1px solid #e5e6e7;
  border-radius: 6pt;
  color: inherit;
  display: block;
  padding: 1.6vh 1.6vh;
  transition: border-color 0.15s ease-in-out 0s, box-shadow 0.15s ease-in-out 0s;
  width: 100%;
  font-size: 20px;
  font-weight: 500;
}

.text-code {
  width: 70%;
  float: left;
}

.form-button {
  margin-top: 2vh;
  margin-bottom: 2vh;
  width: 100%;
  color: black;
  font-size: 20px;
  font-weight: 500;
  padding: 1.6vh 1.6vh;
  text-align: center;
  border: 1pt solid #fff;
  border-radius: 6pt;
}

.button-code {
  margin-left: 4%;
  width: 26%;
  margin-bottom: 0;
  padding: 1.6vh 1.6vh;
}

.button-pay {
  color: green;
  margin-bottom: 0;
}

.button-cancel {
  color: #111111;
  font-weight: 0;
}

.wechat-dev {
  display: flex;
  margin-top: 2vh;
}

.wechat-icon {
  height: 28px;
}

.wechat-desc {
  margin-left: 12px;
  color: white;
  font-size: 20px;
  font-weight: 500;
}

.pay-panel{
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  background: #111111;
  z-index: 1000;
}

.fill-start {
  padding: 3vh 0;
}

.fill-title {
  font-size: 24px;
  font-weight: 500;
  //margin-top: 2vh;
  //color: #666;
  color: gold;
}

.fill-body {
  padding: 2vh;
}

.pay-result{
  padding: 16vh 2vh;
}

.result-status {
  font-size: 36px;
  font-weight: 800;
  //margin-top: 2vh;
  margin-bottom: 8vh;
}

.result-wait {
  color: orange;
}

.result-result {
  font-size: 18px;
  font-weight: 200;
  margin-top: 1vh;
  color: red;
}

.result-text {
  font-size: 18px;
  font-weight: 200;
  margin-bottom: 1vh;
  color: #eeeeee;
}

.result-after {
  display: flex;
  justify-content: space-between;
}

.result-after-content {
  color: white;
  font-size: 16px;
  font-weight: 250;
  margin-top: 1vh;
  text-align: left;
}

.toasted.bubble {
  background-color: var(--main-color) !important;
}

</style>
